export const isCountryLabelMatch = (
  label,
  searchValue
) => {
  if (!label || !searchValue) {
    return false;
  }

  return label.toLowerCase().includes(searchValue.toLowerCase());
};
